import { CredentialEmailModel } from './credentialEmail.model';

export class CredentialEmailConfigurationModel {
  initialEmail: CredentialEmailModel;
  reinstatementEmails: CredentialEmailModel[];
  isRenewalAvailable: boolean;
  isReinstatementAvailable: boolean;
  earliestRenewalOffset?: number;
  latestRenewalOffset?: number;
  earliestReinstatementOffset?: number;
  renewalCompletionEmail: CredentialEmailModel;
  specialtyEmail: SpecialtyEmailModel;
  renewalScheduledEmails: CredentialEmailModel[];

  public static parse(data: CredentialEmailConfigurationModel): CredentialEmailConfigurationModel {
    if (!data) return null;
    let config = new CredentialEmailConfigurationModel();
    config.initialEmail = data.initialEmail;
    config.renewalScheduledEmails = data.renewalScheduledEmails;
    config.renewalCompletionEmail = data.renewalCompletionEmail;
    config.reinstatementEmails = data.reinstatementEmails;
    config.isRenewalAvailable = data.isRenewalAvailable;
    config.isReinstatementAvailable = data.isReinstatementAvailable;
    config.earliestRenewalOffset = data.earliestRenewalOffset;
    config.latestRenewalOffset = data.latestRenewalOffset;
    config.earliestReinstatementOffset = data.earliestReinstatementOffset;
    config.specialtyEmail = data.specialtyEmail;
    return config;
  }
}

class SpecialtyEmailModel {
  credentialEmailModel: CredentialEmailModel;
  isSpecialtyAllowed: boolean;
}
